import styled from 'styled-components';

export const Container = styled('div')`
  overflow: auto;
  overflow-y: hidden;
`;

export const TableSymbol = styled('a')`
  color: ${({ theme }) => theme.color.brand01};
  text-decoration: none;
`;
